// extracted by mini-css-extract-plugin
module.exports = {"startupGaining":"StartupGaining_startupGaining__RLzB8","cards":"StartupGaining_cards__1Cqe5","card":"StartupGaining_card__1i_qR","btn":"StartupGaining_btn__2x-sy"};